module.exports = __webpack_public_path__ + "static/profile-813389de7358ecbc31484daed5e3efb6.png";